import { ReactNode } from 'react';
import './BackOfficeContent.scss';
import classNames from 'classnames';

export function BackOfficeContent({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) {
    return <div className={classNames('BackOfficeContent', className)}>{children}</div>;
}
